/**
 * Accordion block — front-end behavior.
 */
import gsap from 'gsap';

export class AccordionFront {
	/**
	 * @param {HTMLElement} element Root `.accordion-block` section.
	 */
	constructor( element ) {
		this.element = element;
		this.elements();
		this.bind();
	}

	elements() {
		this.items = this.element.querySelectorAll( '.accordion-block-item' );
	}

	bind() {
		this.items.forEach( ( item ) => {
			const trigger = item.querySelector( '[data-accordion-trigger]' );
			const panel = item.querySelector( '[data-accordion-panel]' );

			if ( ! trigger || ! panel ) {
				return;
			}

			item.open = false;
			panel.hidden = false;
			gsap.set( panel, { height: 0, overflow: 'hidden', } );

			trigger.addEventListener( 'click', () => {
				this.toggle( item, trigger, panel );
			} );
		} );
	}

	/**
	 * @param {HTMLElement} item
	 * @param {HTMLButtonElement} trigger
	 * @param {HTMLElement} panel
	 */
	toggle( item, trigger, panel ) {
		if ( ! item.open ) {
			gsap.to( panel, {
				height: 'auto',
				duration: 0.5,
				ease: 'circ.out',
			} );
			item.classList.add( 'active' );
			trigger.setAttribute( 'aria-expanded', 'true' );
		} else {
			gsap.to( panel, {
				height: 0,
				duration: 0.5,
				ease: 'circ.out',
			} );
			item.classList.remove( 'active' );
			trigger.setAttribute( 'aria-expanded', 'false' );
		}

		item.open = ! item.open;
	}
}
